var data = {
	"body": "<path fill=\"#00B0FF\" d=\"M0 110.848V0l96 55.424v36.95l-64-36.95v73.899z\"/><path fill=\"#0081CB\" d=\"M96 55.424L192 0v110.848l-64 36.95l-32-18.475l64-36.95V55.424l-64 36.95z\"/><path fill=\"#00B0FF\" d=\"M96 129.323v36.949l64 36.95v-36.95z\"/><path d=\"M160 203.221l96-55.424V73.9l-32 18.474v36.95l-64 36.949v36.95zm64-147.797v-36.95L256 0v36.95l-32 18.474z\" fill=\"#0081CB\"/>",
	"width": 256,
	"height": 204
};
export default data;
